import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import 'helix-ui';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var handlerNameToEvent = function handlerNameToEvent(handlerName) {
  return handlerName.replace(/^on/, '').toLowerCase();
};
/**
 * Adds event handlers like onOpen or onClose to event listeners: 'open' or 'close'
 * @param {object} eventHandlers such as onClose, onOpen, ...etc
 * @param {React.MutableRefObject} ref
 * @return {React.MutableRefObject}
 */


function useEventListener(eventHandlers, ref) {
  if (eventHandlers === void 0) {
    eventHandlers = {};
  }

  var theRef = ref || useRef(null);
  useEffect(function () {
    Object.entries(eventHandlers).forEach(function (_ref, key) {
      var handlerName = _ref[0],
          eventHandler = _ref[1];
      theRef.current.addEventListener(handlerNameToEvent(handlerName), eventHandler);
    });
    return function () {
      Object.entries(eventHandlers).forEach(function (_ref2, key) {
        var handlerName = _ref2[0],
            eventHandler = _ref2[1];
        theRef.current.removeEventListener(handlerNameToEvent(handlerName), eventHandler);
      });
    };
  }, []);
  return theRef;
}

var Alert = function Alert(_ref) {
  var className = _ref.className,
      children = _ref.children,
      onDismiss = _ref.onDismiss,
      onSubmit = _ref.onSubmit,
      rest = _objectWithoutPropertiesLoose(_ref, ["onOpen", "onClose", "className", "children", "onDismiss", "onSubmit"]);

  var hxRef = useEventListener({
    onDismiss: onDismiss,
    onSubmit: onSubmit
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hx-alert", _extends({
    "class": className,
    ref: hxRef
  }, rest), children));
};

var Icon = function Icon(_ref) {
  var type = _ref.type,
      className = _ref.className,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "className"]);

  return /*#__PURE__*/React.createElement("hx-icon", _extends({
    type: type
  }, rest, {
    "class": className
  }));
};

function cssFor(modifier) {
  return {
    large: 'hxLg',
    primary: 'hxPrimary',
    small: 'hxSm',
    tertiary: 'hxTertiary'
  }[modifier];
}

function classNames(props) {
  return ['hxBtn', cssFor(props.variant), cssFor(props.size), props.className].join(' ').trim();
}

var Button = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Button, _React$Component);

  function Button() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Button.prototype;

  _proto.render = function render() {
    // destructure props for JSX composition
    var _this$props = this.props,
        busy = _this$props.busy,
        children = _this$props.children,
        headIcon = _this$props.headIcon,
        tailIcon = _this$props.tailIcon,
        type = _this$props.type,
        props = _objectWithoutPropertiesLoose(_this$props, ["busy", "children", "className", "headIcon", "size", "tailIcon", "type", "variant"]);

    return /*#__PURE__*/React.createElement("button", _extends({
      className: classNames(this.props),
      type: type || 'button'
    }, props), headIcon && /*#__PURE__*/React.createElement(Icon, {
      type: headIcon
    }), children && /*#__PURE__*/React.createElement("span", null, children), busy ? /*#__PURE__*/React.createElement("hx-busy", null) : tailIcon && /*#__PURE__*/React.createElement(Icon, {
      type: tailIcon
    }));
  };

  return Button;
}(React.Component);

var Checkbox = function Checkbox(_ref) {
  var id = _ref.id,
      label = _ref.label,
      indeterminate = _ref.indeterminate,
      className = _ref.className,
      rest = _objectWithoutPropertiesLoose(_ref, ["id", "label", "indeterminate", "className", "style"]);

  var inputRef = useRef();
  useEffect(function () {
    inputRef.current.indeterminate = indeterminate;
  }, [indeterminate]);
  return /*#__PURE__*/React.createElement("hx-checkbox-control", {
    "class": className
  }, /*#__PURE__*/React.createElement("input", _extends({
    ref: inputRef
  }, rest, {
    id: id,
    type: "checkbox"
  })), /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, /*#__PURE__*/React.createElement("hx-checkbox", null), label));
};

function createCommonjsModule(fn, basedir, module) {
  return module = {
    path: basedir,
    exports: {},
    require: function require(path, base) {
      return commonjsRequire();
    }
  }, fn(module, module.exports), module.exports;
}

function commonjsRequire() {
  throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var classnames = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */

  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
          var inner = classNames.apply(null, arg);

          if (inner) {
            classes.push(inner);
          }
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});
var SIZES = {
  small: 'hxSm',
  medium: 'hxMd',
  large: 'hxLg'
};

/**
 * Because Web components attributes convert booleans to strings
 * this stops values like false from being converted to "false" and then evaluating as true.
 * @param {boolean} bool
 * @return {*}
 */
var wcBool = function wcBool(bool) {
  return bool ? true : null;
};

var ChoiceTile = function ChoiceTile(_ref) {
  var _classNames;

  var checked = _ref.checked,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      icon = _ref.icon,
      invalid = _ref.invalid,
      name = _ref.name,
      onChange = _ref.onChange,
      size = _ref.size,
      subdued = _ref.subdued,
      title = _ref.title,
      style = _ref.style,
      rest = _objectWithoutPropertiesLoose(_ref, ["checked", "children", "className", "disabled", "icon", "invalid", "name", "onChange", "size", "subdued", "title", "style"]);

  return /*#__PURE__*/React.createElement("label", {
    className: classnames({
      hxChoice: true
    }, className),
    style: style
  }, /*#__PURE__*/React.createElement("input", _extends({
    checked: wcBool(checked),
    disabled: disabled,
    invalid: invalid == null ? void 0 : invalid.toString(),
    name: name,
    onChange: onChange,
    type: "radio"
  }, rest)), /*#__PURE__*/React.createElement("hx-tile", {
    "class": classnames((_classNames = {
      hxSubdued: subdued
    }, _classNames[SIZES[size]] = true, _classNames))
  }, /*#__PURE__*/React.createElement("hx-icon", {
    type: "checkmark"
  }), icon && /*#__PURE__*/React.createElement("div", {
    className: "hx-tile-icon"
  }, /*#__PURE__*/React.createElement("hx-icon", {
    type: icon
  })), /*#__PURE__*/React.createElement("header", null, title), children));
};

ChoiceTile.defaultProps = {
  checked: false
};

var Disclosure = function Disclosure(_ref) {
  var className = _ref.className,
      ariaControls = _ref.ariaControls,
      ariaExpanded = _ref.ariaExpanded,
      rest = _objectWithoutPropertiesLoose(_ref, ["className", "ariaControls", "ariaExpanded"]);

  return /*#__PURE__*/React.createElement("hx-disclosure", _extends({
    "class": className,
    "aria-controls": ariaControls,
    "aria-expanded": wcBool(ariaExpanded)
  }, rest));
};

var Div = function Div(_ref) {
  var className = _ref.className,
      rest = _objectWithoutPropertiesLoose(_ref, ["className"]);

  return /*#__PURE__*/React.createElement("hx-div", _extends({
    "class": className
  }, rest));
};

var Drawer = function Drawer(_ref) {
  var children = _ref.children,
      className = _ref.className,
      id = _ref.id,
      onClose = _ref.onClose,
      onOpen = _ref.onOpen,
      open = _ref.open,
      size = _ref.size,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "className", "id", "onClose", "onOpen", "open", "size"]);

  var hxRef = useEventListener({
    onOpen: onOpen,
    onClose: onClose
  });
  return /*#__PURE__*/React.createElement("hx-drawer", _extends({
    "class": classnames(className, SIZES[size]),
    id: id,
    open: wcBool(open),
    ref: hxRef
  }, rest), children);
};

Drawer.defaultProps = {
  open: null
};

var Modal = function Modal(_ref) {
  var onOpen = _ref.onOpen,
      onClose = _ref.onClose,
      className = _ref.className,
      open = _ref.open,
      size = _ref.size,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["onOpen", "onClose", "className", "open", "size", "children"]);

  var hxRef = useEventListener({
    onOpen: onOpen,
    onClose: onClose
  });
  return /*#__PURE__*/React.createElement("hx-modal", _extends({
    "class": classnames(className, SIZES[size]),
    ref: hxRef,
    open: wcBool(open)
  }, rest), children);
};

var Pill = function Pill(_ref) {
  var className = _ref.className,
      children = _ref.children,
      onDismiss = _ref.onDismiss,
      rest = _objectWithoutPropertiesLoose(_ref, ["className", "children", "onDismiss"]);

  var hxRef = useEventListener({
    onDismiss: onDismiss
  });
  return /*#__PURE__*/React.createElement("hx-pill", _extends({
    "class": className
  }, rest, {
    ref: hxRef
  }), children);
};

var PILL_VARIANTS = {
  grey: 'hxEmphasisGray',
  purple: 'hxEmphasisPurple',
  subdued: 'hxSubdued'
};

var Status = function Status(_ref) {
  var className = _ref.className,
      children = _ref.children,
      variant = _ref.variant,
      filled = _ref.filled,
      rest = _objectWithoutPropertiesLoose(_ref, ["className", "children", "variant", "filled"]);

  return /*#__PURE__*/React.createElement("hx-status", _extends({
    "class": classnames(className, PILL_VARIANTS[variant], {
      hxFill: filled
    })
  }, rest), children);
};

var Popover = function Popover(_ref) {
  var onOpen = _ref.onOpen,
      onClose = _ref.onClose,
      onReposition = _ref.onReposition,
      className = _ref.className,
      open = _ref.open,
      children = _ref.children,
      relativeTo = _ref.relativeTo,
      rest = _objectWithoutPropertiesLoose(_ref, ["onOpen", "onClose", "onReposition", "className", "open", "children", "relativeTo"]);

  var hxRef = useEventListener({
    onOpen: onOpen,
    onClose: onClose,
    onReposition: onReposition
  });
  return /*#__PURE__*/React.createElement("hx-popover", _extends({
    "class": classnames(className),
    ref: hxRef,
    open: wcBool(open),
    "relative-to": relativeTo
  }, rest), children);
};

var Radio = function Radio(_ref) {
  var id = _ref.id,
      label = _ref.label,
      className = _ref.className,
      style = _ref.style,
      rest = _objectWithoutPropertiesLoose(_ref, ["id", "label", "className", "style"]);

  return /*#__PURE__*/React.createElement("hx-radio-control", {
    "class": className,
    style: style
  }, /*#__PURE__*/React.createElement("input", _extends({}, rest, {
    id: id,
    type: "radio"
  })), /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, /*#__PURE__*/React.createElement("hx-radio", null), label));
};

var RadioSet = function RadioSet(_ref) {
  var className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["className", "children"]);

  return /*#__PURE__*/React.createElement("hx-radio-set", _extends({
    "class": className
  }, rest), children);
};

/**
 * Identical to React.useEffect, except that it never runs on mount. This is the equivalent of
 * the componentDidUpdate lifecycle function.
 * @see https://stackoverflow.com/questions/53253940/make-react-useeffect-hook-not-run-on-initial-render
 * @param {function:function} effect - A useEffect effect.
 * @param {array} dependencies - useEffect dependency list.
 */
var useEffectExceptOnMount = function useEffectExceptOnMount(effect, dependencies) {
  var mounted = React.useRef(false);
  React.useEffect(function () {
    if (mounted.current) {
      var unmount = effect();
      return function () {
        return unmount && unmount();
      };
    } else {
      mounted.current = true;
    }
  }, dependencies);
  React.useEffect(function () {
    return function () {
      return mounted.current = false;
    };
  }, []);
};
/**
 * @see https://helixdesignsystem.github.io/helix-ui/components/search/
 */


var Search = function Search(_ref) {
  var disabled = _ref.disabled,
      id = _ref.id,
      label = _ref.label,
      className = _ref.className,
      clearLabel = _ref.clearLabel,
      onClear = _ref.onClear,
      optional = _ref.optional,
      required = _ref.required,
      containerId = _ref.containerId,
      value = _ref.value,
      style = _ref.style,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "disabled", "id", "label", "className", "clearLabel", "onClear", "optional", "required", "containerId", "value", "style"]);
  /**
   * Show clear icon when value changes programmatically by triggering 'input' event manually.
   * @see https://stackoverflow.com/questions/23892547/what-is-the-best-way-to-trigger-onchange-event-in-react-js
   */


  var inputRef = useRef();
  useEffectExceptOnMount(function () {
    var input = inputRef.current;
    var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    nativeInputValueSetter.call(input, value);
    var ev = new Event('input', {
      bubbles: true
    });
    input.dispatchEvent(ev);
  }, [value]);
  return /*#__PURE__*/React.createElement("hx-search-control", {
    "class": className,
    id: containerId,
    style: style
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: id,
    value: value,
    ref: inputRef
  }, rest, {
    disabled: wcBool(disabled),
    type: "search"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "hxClear",
    "aria-label": clearLabel,
    hidden: true,
    onClick: onClear
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "times"
  })), /*#__PURE__*/React.createElement("hx-search", null), label && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      hxOptional: optional,
      hxRequired: required
    }),
    htmlFor: id
  }, label));
};

Search.defaultProps = {
  clearLabel: 'Clear search'
};
/**
 * @see https://helixdesignsystem.github.io/helix-ui/elements/hx-search-assistance/
 */

var SearchAssistance = function SearchAssistance(_ref) {
  var children = _ref.children,
      className = _ref.className,
      relativeTo = _ref.relativeTo,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "className", "relativeTo"]);

  return /*#__PURE__*/React.createElement("hx-search-assistance", _extends({
    "class": className,
    "relative-to": relativeTo
  }, rest), children);
};

var supportsPassiveEvents;

function arePassiveEventsSupported() {
  if (supportsPassiveEvents !== undefined) {
    return supportsPassiveEvents;
  }

  var passive = false;
  var options = {
    // @ts-ignore: this is a temporary object, it doesn't have to return anything
    get passive() {
      passive = true;
    }

  };

  var noop = function noop() {};

  window.addEventListener('t', noop, options);
  window.removeEventListener('t', noop, options);
  supportsPassiveEvents = passive;
  return passive;
}

var index = useLayoutEffect;

var useLatest = function useLatest(value) {
  var ref = useRef(value);
  index(function () {
    ref.current = value;
  });
  return ref;
};

var MOUSEDOWN = 'mousedown';
var TOUCHSTART = 'touchstart';
var events = [MOUSEDOWN, TOUCHSTART];

var getOptions = function getOptions(event) {
  if (event !== TOUCHSTART) {
    return;
  }

  if (arePassiveEventsSupported()) {
    return {
      passive: true
    };
  }
};

function useOnClickOutside(ref, handler) {
  var handlerRef = useLatest(handler);
  useEffect(function () {
    if (!handler) {
      return;
    }

    var listener = function listener(event) {
      if (!ref.current || !handlerRef.current || ref.current.contains(event.target)) {
        return;
      }

      handlerRef.current(event);
    };

    events.forEach(function (event) {
      document.addEventListener(event, listener, getOptions(event));
    });
    return function () {
      events.forEach(function (event) {
        document.removeEventListener(event, listener, getOptions(event));
      });
    };
  }, [!handler]);
}
/**
 * @see https://helixdesignsystem.github.io/helix-ui/components/search/
 */


var SearchAssist = function SearchAssist(_ref) {
  var children = _ref.children,
      _onFocus = _ref.onFocus,
      position = _ref.position,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "onFocus", "onBlur", "position"]);

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var searchRef = useRef();
  useOnClickOutside(searchRef, function () {
    return setOpen(false);
  });
  var hasChildren = React.Children.toArray(children).filter(function (c) {
    return c;
  }).length > 0;
  return /*#__PURE__*/React.createElement("div", {
    ref: searchRef
  }, /*#__PURE__*/React.createElement(Search, _extends({}, rest, {
    onFocus: function onFocus(e) {
      setOpen(true);
      _onFocus && _onFocus(e);
    },
    containerId: rest.id + "-hx-search-control"
  })), hasChildren && /*#__PURE__*/React.createElement(SearchAssistance, {
    relativeTo: rest.id + "-hx-search-control",
    open: wcBool(open),
    position: position,
    onClick: function onClick() {
      return setOpen(false);
    }
  }, children));
};

var Select = function Select(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      id = _ref.id,
      label = _ref.label,
      onChange = _ref.onChange,
      optional = _ref.optional,
      required = _ref.required,
      style = _ref.style,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "className", "disabled", "id", "label", "onChange", "optional", "required", "style"]);

  return /*#__PURE__*/React.createElement("hx-select-control", {
    "class": className,
    style: style
  }, /*#__PURE__*/React.createElement("select", _extends({
    id: id,
    disabled: disabled,
    onChange: onChange,
    required: required
  }, rest), children), /*#__PURE__*/React.createElement("hx-select", null), label && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      hxOptional: optional,
      hxRequired: required
    }),
    htmlFor: id
  }, label));
};

var Switch = function Switch(_ref) {
  var id = _ref.id,
      className = _ref.className,
      onLabel = _ref.onLabel,
      offLabel = _ref.offLabel,
      invalid = _ref.invalid,
      rest = _objectWithoutPropertiesLoose(_ref, ["id", "className", "onLabel", "offLabel", "invalid"]);

  return /*#__PURE__*/React.createElement("hx-switch-control", {
    "class": classnames('switch', className)
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    id: id
  }, rest, {
    invalid: invalid == null ? void 0 : invalid.toString()
  })), /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, /*#__PURE__*/React.createElement("hx-switch", {
    onlabel: onLabel,
    offlabel: offLabel,
    "aria-labelledby": id
  })));
};

Switch.defaultProps = {
  onLabel: '',
  offLabel: ''
};

var Text = function Text(_ref) {
  var id = _ref.id,
      label = _ref.label,
      className = _ref.className,
      required = _ref.required,
      optional = _ref.optional,
      children = _ref.children,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      style = _ref.style,
      rest = _objectWithoutPropertiesLoose(_ref, ["id", "label", "className", "required", "optional", "children", "prefix", "suffix", "style"]);

  return /*#__PURE__*/React.createElement("hx-text-control", {
    "class": className,
    style: style
  }, /*#__PURE__*/React.createElement("input", _extends({}, rest, {
    id: id,
    required: required,
    type: "text"
  })), /*#__PURE__*/React.createElement("label", {
    className: classnames({
      hxOptional: optional,
      hxRequired: required
    }),
    htmlFor: id
  }, label), prefix && /*#__PURE__*/React.createElement("span", {
    className: "hxPrefix"
  }, prefix), suffix && /*#__PURE__*/React.createElement("span", {
    className: "hxSuffix"
  }, suffix), children);
};

var TextArea = function TextArea(_ref) {
  var id = _ref.id,
      label = _ref.label,
      className = _ref.className,
      required = _ref.required,
      optional = _ref.optional,
      children = _ref.children,
      style = _ref.style,
      rest = _objectWithoutPropertiesLoose(_ref, ["id", "label", "className", "required", "optional", "children", "style"]);

  return /*#__PURE__*/React.createElement("hx-textarea-control", {
    "class": className,
    style: style
  }, /*#__PURE__*/React.createElement("textarea", _extends({}, rest, {
    id: id,
    required: required
  })), /*#__PURE__*/React.createElement("label", {
    className: classnames({
      hxOptional: optional,
      hxRequired: required
    }),
    htmlFor: id
  }, label), children);
};

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      id = _ref.id,
      position = _ref.position;
  return /*#__PURE__*/React.createElement("hx-tooltip", {
    "for": id,
    position: position
  }, children);
};

Tooltip.defaultProps = {
  position: 'top-left'
};
export { Alert, Button, Checkbox, ChoiceTile, Disclosure, Div, Drawer, Icon, Modal, Pill, Popover, Radio, RadioSet, Search, SearchAssist, Select, Status, Switch, Text, TextArea, Tooltip };